


import React from 'react'

function CheckboxIcon({color="#e1e1e1",size=27}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 27 27">
    <g id="Group_23" data-name="Group 23" transform="translate(-423 -108)">
      <circle id="Ellipse_24" data-name="Ellipse 24" cx="13.5" cy="13.5" r="13.5" transform="translate(423 108)" fill={color}/>
      <g id="check" transform="translate(429.859 46.133)">
        <path id="Path_47" data-name="Path 47" d="M4.288,80.16a1.419,1.419,0,0,1-1-.416L.245,76.707a.837.837,0,0,1,0-1.184h0a.837.837,0,0,1,1.184,0l2.859,2.859,7.563-7.563a.837.837,0,0,1,1.184,0h0a.837.837,0,0,1,0,1.184L5.293,79.744A1.419,1.419,0,0,1,4.288,80.16Z" fill="#fff"/>
      </g>
    </g>
  </svg>
  
  )
}

export default CheckboxIcon;